import { DataBean } from "../DataBean";

export class ExpProdRoute extends DataBean {



    public async exportProductionRoute(idProductionRoute: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProductionRoute_Number", [idProductionRoute]);
    }

}